// Token storage helper.
// JWT tokens are kept in sessionStorage (not localStorage) to reduce the XSS attack surface:
//  - sessionStorage is cleared when the browser/tab is closed
//  - it is not shared between tabs the way localStorage is
// User profile data (non-sensitive: name, role, language preference) stays in localStorage
// so we can restore the i18n language even before the auth call returns.

const TOKEN_KEY = 'ev_token';

export const tokenStorage = {
  get() {
    try {
      return sessionStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set(token) {
    try {
      sessionStorage.setItem(TOKEN_KEY, token);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn('[auth] could not persist token:', err);
    }
  },
  clear() {
    try {
      sessionStorage.removeItem(TOKEN_KEY);
      // Legacy cleanup: older builds stored the token in localStorage.
      // Remove it so users don't keep a stale token after upgrading.
      localStorage.removeItem(TOKEN_KEY);
    } catch {
      // ignore
    }
  },
  // Migration helper: if a token survives from a previous (localStorage-based) build,
  // copy it into sessionStorage on first read so users aren't forced to re-login once.
  migrateLegacy() {
    try {
      const legacy = localStorage.getItem(TOKEN_KEY);
      if (legacy && !sessionStorage.getItem(TOKEN_KEY)) {
        sessionStorage.setItem(TOKEN_KEY, legacy);
      }
      // remove the old copy regardless
      localStorage.removeItem(TOKEN_KEY);
    } catch {
      // ignore
    }
  },
};
